import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Product } from '../../../../../../modules/API/Products/products';
import { handleNotifications } from '../../../../../../generic/utils/handleNotifications';
import { LOGOUT } from '../../../../../../../store/actions/actionsTypes';
import { ProductGroup } from '../../types';

const useProductGroups = () => {
    const dispatch = useDispatch();
    const [productGroups, setProductGroups] = useState<ProductGroup[]>([]);
    const [productGroupsDefault, setProductGroupsDefault] = useState<ProductGroup[]>([]);
    // Read-only copy for the orders list filter: the create-order form overwrites the two states above.
    const [productGroupsCatalog, setProductGroupsCatalog] = useState<ProductGroup[]>([]);
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        const load = async () => {
            try {
                const response = await Product.getProductGroups();
                if (!isMounted.current) return;
                setProductGroups(response.productsGroups);
                setProductGroupsDefault(response.productsGroups);
                setProductGroupsCatalog(response.productsGroups);
            } catch (err: any) {
                if (!isMounted.current) return;
                if (err?.response?.status === 404) return;
                const message = err?.response?.data?.message;
                if (message) {
                    handleNotifications(message, { type: 'error' });
                }
                if (message === 'jwt malformed' || message === 'jwt expired') {
                    dispatch({ type: LOGOUT, payload: false });
                }
            }
        };
        load();
        return () => {
            isMounted.current = false;
        };
    }, [dispatch]);

    return {
        productGroups,
        productGroupsDefault,
        productGroupsCatalog,
        setProductGroups,
        setProductGroupsDefault,
    };
};

export default useProductGroups;
